// // En src/utils/imageUtils.ts
// export const getImageUrl = (imagePath: string | undefined): string => {
//     if (!imagePath) {
//         return 'https://images.unsplash.com/photo-1546069901-ba9599a7e63c?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80'; // imagen por defecto
//     }

//     // Si ya es una URL completa del backend, usarla directamente
//     if (imagePath.includes('backendcomerbien-production.up.railway.app')) {
//         return imagePath;
//     }

//     // Si es una ruta relativa o solo el nombre del archivo, construir URL completa
//     if (imagePath.startsWith('/api/files/')) {
//         return `https://backendcomerbien-production.up.railway.app${imagePath}`;
//     }

//     // Si es solo el nombre del archivo
//     return `https://backendcomerbien-production.up.railway.app/api/files/${imagePath}`;
// };
export const getCorrectImageUrl = (imagePath: string | undefined | null): string => {
    if (!imagePath) {
        return 'https://images.unsplash.com/photo-1546069901-ba9599a7e63c?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80';
    }

    // Si ya es una URL completa
    if (imagePath.startsWith('http')) {
        return imagePath;
    }

    // Determinar backend URL basado en el entorno
    const backendUrl = import.meta.env.PROD 
        ? 'https://backendcomerbien-production.up.railway.app'
        : 'http://localhost:8081';

    // Manejar diferentes formatos de imagePath
    if (imagePath.startsWith('/api/files/')) {
        return `${backendUrl}${imagePath}`;
    }
    
    // Si es solo un UUID o nombre de archivo
    return `${backendUrl}/api/files/${imagePath}`;
};